import connect from "@classdojo/web/utils/hoc/connect";
import RadioDisplay from "./RadioDisplay";
import { appMetadataRadio, Radio, RadioChannel, sendRadio, SendRadioProps } from "src/pods/radio";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";

type RadioDisplayState = {
  radio: Radio;
};

type RadioDisplayProps = {
  displayClose: VoidFunction;
  sendRadio: (params: SendRadioProps) => void;
  channel: RadioChannel;
  currentTrackIndex: number;
  playing: boolean;
};

const mapStateToProps = (state: RadioDisplayState) => {
  return { ...state.radio };
};
const mapDispatchToProps = { sendRadio, displayClose };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Partial<RadioDisplayProps>) => (
  <PresentationPage
    sx={{
      minHeight: "100%",
      overflow: "hidden",
      backgroundImage: "linear-gradient(to bottom, #ffb400, #ff772d)",
    }}
    backgroundColor={appMetadataRadio().backgroundColor}
    onRequestHide={props.displayClose}
  >
    <RadioDisplay
      displayClose={props.displayClose}
      channel={props.channel}
      currentTrackIndex={props.currentTrackIndex}
      playing={props.playing}
      sendRadio={props.sendRadio}
    />
  </PresentationPage>
));
